import React from "react";

// Components
import {FormPageLayout} from "../../components/layout/FormPageLayout";
import {NAVIGATION_BAR_HEIGHT} from "../../designSystem/tokens/spacing";
import {ResetPasswordFeature} from "../../features/resetPassword";

const
  ResetPasswordPage = () => (
  <FormPageLayout
    height={NAVIGATION_BAR_HEIGHT.LARGE}
    body={
      <ResetPasswordFeature />
    }
  />
);

export default ResetPasswordPage;
